module.exports = __webpack_public_path__ + "static/media/um.485d400b.svg";